/* eslint-disable array-callback-return */
import React, {FC} from "react";
import {useAppSelector} from "../../../../hooks/redux";
import {getLanguage} from "../../../../store/selectors/appSelector";
import style from "./Navigation.module.css";
import {useLocation, useNavigate} from "react-router-dom";
import {pages} from "../../../../pages/pagesConfig";
import {getTextByLanguage} from "../../../../enums/utils/getTextByLanguage";

export const Navigation: FC = (key) => {

    const language = useAppSelector(getLanguage);
    const navigate = useNavigate()
    const {pathname} = useLocation()

    const onClickHandler = (path: string) => {
        if (pathname !== path) {
            navigate(path)
        }
    }

    return (
        <nav className={style.nav}>
            <ul className={style.navWrapper}>

                {pages.map((page, index) => {
                    if (page.status && page.inNavigation) {
                        return (
                            <li key={`${key}_${index}`} onClick={() => onClickHandler(page.path)}>
                                {getTextByLanguage(page.title, language)}
                            </li>
                        )
                    }
                })}
            </ul>
        </nav>
    )
};